import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface ParameterGroupsDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ParameterGroupsDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: ParameterGroupsDeleteProps) => {
  const { t } = useTranslation();

  return (
    <CustomSharedConfirmationModal
      open={open}
      title={t("delete_parameter_group")}
      description={t("delete_parameter_group_confirmation")}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default ParameterGroupsDelete;
